import styled from "styled-components";
import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;

  position: relative;

  & > button {
    position: absolute;
    right: 13px;
    background: transparent;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  padding: 13px;

  border-radius: ${theme.border.smallRadius};
  border: 1px solid #b9c1cb;
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
  background: ${theme.colors.white};
  font-size: ${theme.font.sizes.small};
  line-height: ${theme.font.sizes.normal};
  font-family: ${theme.font.montserrat};
  color: ${theme.colors.gray300};

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #c4c4c4;
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #c4c4c4;
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #c4c4c4;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #b9c1cb;
  margin-top: 8px;
`;
